<template>
    <div class='margin'>
        <div class='row'>
            <div class='width-25pct'>
                <widget-facture></widget-facture>
            </div>
            <div class='width-35pct margin-left-30px'>
                <widget-reglement></widget-reglement>
            </div>
            <div class='width-35pct margin-left-30px'>
                <widget-document></widget-document>
            </div>
        </div>
        <div class='margin factures'>
            {{$t('dashboard.fournisseur.infos.factures.message')}}
            <span @click='modaleOpen = true' class='details'> {{$t('dashboard.fournisseur.infos.factures.details')}}</span>
            <span class="regles-pastilles-group">
                <ReglePastille cle="dashboardFournisseur.definition" />
                <ReglePastille cle="dashboardFournisseur.coordonneesFacturation" />
            </span>
        </div>
    </div>
    <Modal v-if='modaleOpen' @cancel='modaleOpen = false'>
        <div class='container-modale'>
            <table>
                <tr v-for='(item) in societeTriees()' :key='item[1]'>
                    <td>{{item.societe}}</td>
                    <td>{{item.mail}}</td>
                </tr>
            </table>
        </div>
    </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import WidgetFacture from '@/modules/DashboardFournisseur/components/WidgetFacture.vue';
import WidgetReglement from '@/modules/DashboardFournisseur/components/WidgetReglement.vue';
import WidgetDocument from '@/modules/DashboardFournisseur/components/WidgetDocument.vue';
import { FactureFournisseurStatsDTO } from '@/models/FactureFournisseurStatsDTO';
import { store } from '@/plugins/store';
import { MENU } from '@/components/layout/store/mutation-types';
import { MENU_FOURNISSEUR, MENU_FOURNISSEUR_SWITCH_CLIENT } from '@/components/layout/store/state';
import { DashboardFournisseurActions } from '@/modules/DashboardFournisseur/store/action-types';
import Modal from '@/components/ui-components/Modal.vue';
import ReglePastille from '@/components/regles/ReglePastille.vue';

interface Data {
    statsfactures: FactureFournisseurStatsDTO;
    modaleOpen: boolean;
    mails: any;
}

export default defineComponent({
    name: 'DashboardFournisseur',
    components: { Modal, WidgetDocument, WidgetReglement, WidgetFacture, ReglePastille },
    data(): Data {
        return {
            statsfactures: {
                nbAValider: 0,
                nbLitige: 0,
                nbRejetees: 0,
                nbValidees: 0,
                nbPayees: 0
            },
            modaleOpen: false,
            mails: [
                {societe: 'HERVE THERMIQUE', mail: 'facture11@herve-thermique.com'},
                {societe: 'Le Dix', mail: 'facture24@ledixparis.com'},
                {societe: 'BSE', mail: 'facture12@bs-energies.fr'},
                {societe: 'TOLERIE INDUSTRIELLE', mail: 'facture16@t-i.fr'},
                {societe: 'HERVE MAROC', mail: 'facture@herve-maroc.ma'},
                {societe: 'ACTEM OTEL', mail: 'facture18@actemotel.com'},
                {societe: 'ALERTEO', mail: 'facture21@alerteo.com'},
                {societe: 'IMMONELIA', mail: 'facture23@immonelia.com'},
                {societe: 'GUARD\'S FORMATION', mail: 'facture26@guards-conseil-formation.com'},
                {societe: 'YSPL', mail: 'facture27@servicepro.mu'},
                {societe: 'HERVE Portugal', mail: 'facture29@herve-portugal.pt'},
                {societe: 'MATHECO', mail: 'facture30@matheco-cooling.be'},
                {societe: 'FINANCIERE HERVE', mail: 'facture33@groupeherve.com'},
                {societe: 'SEIM-N', mail: 'facture38@seim-n.fr'},
                {societe: 'FABKIT', mail: 'facture29@herve-portugal.pt'},
                {societe: 'ENTREPRISE SMC', mail: 'facture@groupeherve.com'},
                {societe: 'SMCT', mail: 'facture43@smct.fr'},
                {societe: 'CHOUTEAU ATLANTIQUE', mail: 'facture44@chouteauatlantique.fr'},
                {societe: 'CTL', mail: 'facture47@ctl-lorient.fr'},
                {societe: 'SN HYDRO', mail: 'facture50@snhydro.fr'},
                {societe: 'PELZER', mail: 'facture52@pelzergroup.be'},
                {societe: 'HERVE CONCEPT', mail: 'facture53@herve-concept.com'},
                {societe: 'PELZER Luxembourg', mail: 'facture55@pelzergroup.be'},
                {societe: 'CEL', mail: 'facture@groupeherve.com'},
                {societe: 'IMDEO', mail: 'facture77@imdeo.com'},
                {societe: 'BUCHARD', mail: 'facture78@buchard-sa.ch'},
                {societe: 'CONSORTIUMS SUISSES', mail: 'facture80@alvazzigroupe.com'},
                {societe: 'ALVAZZI', mail: 'facture81@alvazzigroupe.com'},
                {societe: 'ALVAZZI GROUPE SA', mail: 'facture83@alvazzigroupe.com'}
            ]
        };
    },
    async beforeMount() {
        if (localStorage.getItem('isFournisseur') === 'true' && localStorage.getItem('isClient') === 'true') {
            store.commit(`menuState/${MENU.SET_MENU}`, MENU_FOURNISSEUR_SWITCH_CLIENT);
        } else {
            store.commit(`menuState/${MENU.SET_MENU}`, MENU_FOURNISSEUR);
        }
        await this.getStatsFactures();
        await this.getDerniersRegelements();
    },
    methods: {
        async getStatsFactures() {
            await store.dispatch(`dashboardFournisseurState/${DashboardFournisseurActions.GET_STATS}`);
        },
        async getDerniersRegelements() {
            await store.dispatch(`dashboardFournisseurState/${DashboardFournisseurActions.GET_CINQ_DERNIERS_REGLEMENTS}`);
        },
        societeTriees() {
            return this.mails.sort((a: any, b: any) => a.societe.localeCompare(b.societe));
        }
    }
});
</script>

<style scoped>
.regles-pastilles-group {
    display: inline-flex;
    align-items: center;
    gap: 16px;
}
.margin {
    margin: 20px 30px 10px 40px;
}
.width-25pct {
    width: 25%;
}
.width-35pct {
    width: 35%;
}
.margin-left-30px {
    margin-left: 30px;
}
.row {
    display: flex;
}
.red {
    color: red;
}
.img {
    width: 5vw;
}
.column {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
}
.message-temporaire {
    font-size: 14px;
}
.factures {
    display: flex;
    justify-content: center;
    font-weight: bold;
}
.details {
    cursor: pointer;
    color: blue;
}
.container-modale {
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
    0 1px 5px rgba(0, 0, 0, 0.12);
    padding: 30px 30px 15px 30px;
}
</style>
